import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ant-upload-drag-icon" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ant-upload-drag-icon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Clique para selecionar ou arraste o arquivo XML até aqui", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock("div", {
      key: 'CHAVE-UP-NFE' + _ctx.state.chaveUpload,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selecionarXmlUpload && _ctx.selecionarXmlUpload(...args))),
      class: "ant-upload ant-upload-drag",
      onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("input", {
          id: "selecionarXmlNFe",
          type: "file",
          accept: "",
          multiple: "",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarXml && _ctx.enviarXml(...args))),
          style: {"display":"none"}
        }, null, 32),
        _createElementVNode("div", {
          class: "ant-upload-drag-container",
          onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
        }, [
          ((_ctx.state.enviandoXml))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, [
                  _createVNode(_component_a_spin, { size: "large" })
                ]),
                _hoisted_4
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _createVNode(_component_icone, {
                    style: {"font-size":"40px"},
                    nome: "upload-nuvem"
                  })
                ]),
                _hoisted_7
              ]))
        ], 32)
      ])
    ], 32))
  ]))
}